<template>
  <div class="topNavigation" v-if="!$isInIframe">
    <navigation
      showChat
      @item-click="onItemClick"
      :menu="menuItems"
      :dropdown="dropDownOptions"
      :icons="iconMenuItems"
      :profile="profileMenuItems"
      @chat="chatClick()"
      :chatActive="isChatActive"
    >
      <template #customMenuItem>
        <div
          class="relative inline-block text-left cursor-pointer mt-1"
          v-if="consignmentMenuCount > 1"
          @mouseleave="hideMenu()"
        >
          <div>
            <button
              @click.prevent="toggleMenu()"
              type="button"
              class="inline-flex text-white w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold shadow-xs"
              id="menu-button"
              aria-expanded="true"
              aria-haspopup="true"
            >
              Mijn magazijn
              <svg
                class="-ml-1 size-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div
            id="consignmentMenu"
            :class="showConsignmentMenu ? 'block' : 'hidden'"
            class="absolute z-10 w-56 origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-hidden"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabindex="-1"
          >
            <div class="py-1" role="none">
              <div
                v-for="(item, index) in consignmentMenus"
                :key="index"
                class="cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                @click.prevent="handleClick(item.href)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #notifications>
        <div class="relative inline-block text-left">
          <div>
            <button
              type="button"
              class="relative ml-auto flex-shrink-0 rounded-full text-white p-2 hover:outline-none hover:text-pdsPrimaryColor hover:bg-white hover:rounded-b-lg hover:rounded-t-lg"
              id="menu-button"
              aria-expanded="true"
              aria-haspopup="true"
              v-clickout="toggleNotifications"
              @click="toggleNotifications"
            >
              <span class="sr-only">Open options</span>
              <BellIcon class="h-6 w-6" aria-hidden="true" @click.prevent="handleNotificationClick" />
              <span
                class="absolute top-0 right-0 rounded-full w-5 h-5 bg-cta text-center text-xs content-around"
                v-if="transformedToDos && transformedToDos.length > 0"
              >
                {{ transformedToDos.length }}
              </span>
              <span class="absolute top-0 right-0 rounded-full w-5 h-5 bg-cta" v-else-if="notificationUnreadStatus" />
            </button>
          </div>
          <div
            v-if="showNotifications"
            class="absolute md:right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabindex="-1"
          >
            <div class="py-1" role="none">
              <div class="grid grid-rows">
                <div class="actions mx-4 mt-2" v-if="transformedToDos.length > 0">
                  <div class="flex font-bold text-black text-base border-b border-gray-200 items-center pb-2">
                    <ListBulletIcon class="h-4 w-4 mr-2" aria-hidden="true" />
                    Acties ({{ transformedToDos.length }})
                  </div>
                  <div
                    v-for="(todo, index) in transformedToDos.slice(0, 3)"
                    :key="todo.Id"
                    :data-index="index"
                    class="border-b border-gray-200 my-2"
                    @click.prevent="goToPath(todo)"
                  >
                    <div class="flex items-center my-2">
                      <div class="flex-1 cursor-pointer">
                        <div class="text-sm">{{ todo.typeInfo?.title }}</div>
                        <div class="text-xs text-pdsPrimaryColor">{{ todo.customerName }}</div>
                      </div>
                      <ChevronRightIcon class="h-5 w-5 text-gray-400 cursor-pointer" aria-hidden="true" />
                    </div>
                  </div>
                  <div class="flex cursor-pointer text-sm text-primary-default">
                    <div class="flex font-bold" @click.prevent="redirectToTodos">
                      Ga naar alle acties
                      <ArrowRightIcon class="h-5 w-5 flex-shrink-0 ml-2 text-primary-default" aria-hidden="true" />
                    </div>
                  </div>
                </div>
                <div class="news mx-4 my-2" v-if="newsItems.length > 0">
                  <div class="flex font-bold text-black text-base border-b border-gray-200 items-center pb-2">
                    <EnvelopeIcon class="h-4 w-4 mr-2" aria-hidden="true" />
                    Nieuws ({{ newsItems.length }})
                  </div>
                  <div
                    v-for="(item, index) in newsItems.slice(0, 3)"
                    :key="item.Id"
                    :data-index="index"
                    class="border-b border-gray-200"
                  >
                    <router-link :to="'/nieuwsdetail/' + item.Id">
                      <div>
                        <div class="my-1 text-xs font-bold text-tdefault-color">
                          {{ $formatDate(item.PublishDate) }}
                        </div>
                        <div class="my-1 text-sm max-h-16 overflow-hidden font-bold text-talternative-color">
                          {{ item.Title }}
                        </div>

                        <p class="text-xs text-tdefault-color truncate h-8 text-wrap">
                          {{ item.IntroText }}
                        </p>
                        <div class="max-h-16 overflow-hidden my-1">
                          <div
                            class="pb-1 flex float-left"
                            v-for="(ta, index) in item.TreatmentAreas"
                            :key="ta"
                            :data-index="index"
                          >
                            <span
                              v-if="ta === '0001'"
                              class="bg-pdsPrimaryColor relative rounded px-1.5 py-1.5 text-xs text-white mr-2"
                            >
                              Diabetes
                            </span>
                            <span
                              v-else
                              class="bg-pdsPrimaryColor relative rounded px-1.5 py-1.5 text-xs text-white mr-2"
                            >
                              {{ ta }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div class="flex cursor-pointer text-sm text-primary-default my-2">
                    <router-link to="/nieuws" class="flex font-bold">
                      Ga naar alle nieuwsberichten
                      <ArrowRightIcon class="h-5 w-5 flex-shrink-0 ml-2 text-primary-default" aria-hidden="true" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </navigation>
  </div>
</template>
<script>
import router from '@/router';
import { pushDepartmentChangedEvent } from './departmentChangedEventStream';
import { availableDepartments$, activeDepartment$, navigation$ } from '@/services';
import { tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { formLogout, currentUserIdentity$, availablePortals$, pushActivePortalCode } from '@/services';
import Navigation from '@/components/webcomponents/Navigation';
import { ref, onMounted, getCurrentInstance, computed, watch } from 'vue';
import { useStore, mapActions } from 'vuex';
import { BellIcon } from '@heroicons/vue/24/outline';
import { ListBulletIcon, EnvelopeIcon, ArrowRightIcon, ChevronRightIcon } from '@heroicons/vue/20/solid';
import { getToDoTypeInfo } from '../toDos/toDoTypeInfo';
import { getOsaOverviewDetails } from '@/services';

export default {
  name: 'TopNavigation',
  components: {
    Navigation,
    BellIcon,
    ListBulletIcon,
    EnvelopeIcon,
    ArrowRightIcon,
    ChevronRightIcon
  },
  setup() {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const profileMenuItems = [
      { title: 'Mijn gegevens', href: '/accountgegevens' },
      { title: 'Uitloggen', href: '', type: 'Logout' }
    ];
    const store = useStore();
    const isChatActive = computed(() => store.getters['navigation/getChatStatus']);
    const updateResults = (value) => store.dispatch('navigation/updateResults', value);
    const selectedDepartmentChange = (value) => store.dispatch('login/selectedDepartmentChange', value);
    const fetchResults = () => store.dispatch('navigation/fetchResults');
    const setPrescriberChatIframe = (value) => store.commit('prescriber/setPrescriberChatIframe', value);
    const fetchDepotMaterialDetails = () => store.dispatch('navigation/fetchDepotMaterialDetails');
    const fetchNewsItems = () => store.dispatch('news/fetchNewsItems', 3);
    // Define reactive variables
    const menuItems = ref([]);
    const iconMenuItems = ref([]);
    const dropDownOptions = ref(null);
    const availableDepartments = ref(null);
    const activeDepartment = ref(null);
    const availablePortals = ref(null);
    const user = ref(null);
    const results = ref(null);
    const showNotifications = ref(false);
    const toDos = computed(() => store.getters['navigation/getNotificationTods']);
    const notificationLastClicked = ref(window.localStorage.getItem('notificationLastClicked'));
    const transformedToDos = computed(() =>
      toDos.value
        .filter((toDo) => toDo.assignedToUserId === user.value?.id && !toDo.isArchive && !toDo.departmentToDo)
        .map((toDo) => ({
          ...toDo,
          typeInfo: getToDoTypeInfo(toDo),
          Omschrijving: {
            text: toDo.typeInfo?.title || '',
            subText: toDo.typeInfo?.description || ''
          },
          Patiënt: toDo.customerName || '',
          'Taak voor': toDo.assignedToUserName || '',
          Datum: toDo.activateOn || ''
        }))
        .sort((a, b) => {
          const textA = (a.Omschrijving.text + a.Omschrijving.subText).toLowerCase();
          const textB = (b.Omschrijving.text + b.Omschrijving.subText).toLowerCase();
          return textA.localeCompare(textB);
        })
    );
    const latestDateTime = computed(() => {
      const todoDates = transformedToDos.value.map((item) => new Date(item.activateOn));
      const newsDates = newsItems.value.map((item) => new Date(item.PublishDate));
      const allDates = [...todoDates, ...newsDates];
      if (allDates.length === 0) return null;
      const latest = new Date(Math.max(...allDates));
      return latest;
    });
    const notificationUnreadStatus = computed(() => {
      if (!latestDateTime.value) return false;
      if (!notificationLastClicked.value) return true;
      const lastClickedDate = new Date(notificationLastClicked.value);
      const latestDate = latestDateTime.value;
      return latestDate > lastClickedDate;
    });
    const consignmentMenuItems = ref(null);
    const showConsignmentMenu = ref(true);
    let consignmentMenuCount = 0;
    let consignmentMenus = [];
    showConsignmentMenu.value = false;
    const initNavigation = (results) => {
      iconMenuItems.value = [];
      menuItems.value =
        results.navigationItems.find((navigationItem) => navigationItem.type === 'Dashboard')?.childNodes || [];
      menuItems.value.forEach((obj) => {
        obj.href = obj.relativeUri;
      });
      consignmentMenuItems.value =
        results.consignmentMenuItems.find((navigationItem) => navigationItem.type === 'Dashboard')?.childNodes || [];
      consignmentMenuItems.value.forEach((obj) => {
        consignmentMenuCount = consignmentMenuCount + 1;
        obj.href = obj.relativeUri;
      });
      // Check if navigation items with type 'AboutMediq' exist
      const aboutMediqItems = results.navigationItems.find((item) => item.type === 'AboutMediq');
      const aboutMediqOptions = aboutMediqItems ? aboutMediqItems.childNodes : [];
      // Check if navigation items with type 'ServiceAndContact' exist
      const serviceAndContactItems = results.navigationItems.find((item) => item.type === 'ServiceAndContact');
      const serviceAndContactHref = serviceAndContactItems ? serviceAndContactItems.relativeUri : '';
      // Push items to iconMenuItems.value
      if (aboutMediqItems) {
        iconMenuItems.value.push({
          title: 'Information',
          icon: 'InformationCircleIcon',
          type: 'AboutMediq',
          options: aboutMediqOptions
        });
      }
      if (serviceAndContactItems) {
        iconMenuItems.value.push({
          title: 'Service en Contacten',
          icon: 'QuestionMarkCircleIcon',
          type: 'ServiceAndContact',
          href: serviceAndContactHref
        });
      }
      const giveYourOpinionItems = results.navigationItems.filter((item) => item.type === 'GiveYourOpinion');
      const pienItems = results.navigationItems.filter((item) => item.type === 'Pien');
      iconMenuItems.value.find((navigationItem) => {
        if (navigationItem.type === 'AboutMediq') {
          navigationItem.options.push(...giveYourOpinionItems, ...pienItems);
          navigationItem.options.forEach((obj) => {
            obj.href = obj.relativeUri;
          });
        }
      });
      const instititionIds = availableDepartments.value.map(({ ppwRecId, name }) => ({
        ppwRecId: ppwRecId,
        title: name
          .toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ')
      }));
      const addDepartmentSelector = instititionIds.map((id) => ({ ...id, id: 'department-selector' }));
      let institutionObject = {
        title: instititionIds.length > 0 ? instititionIds[0].title : '',
        child: addDepartmentSelector,
        class: 'department-items',
        icon: {
          element: 'img',
          attributes: {
            src: `/icons/building.svg`
          }
        }
      };
      let departmentArray = institutionObject.child;
      const selectedNavigationDepartment = departmentArray.find(
        (childItem) => childItem.ppwRecId === activeDepartment.value.ppwRecId
      );
      // Remove selected department from current index
      departmentArray.filter((item) => item !== selectedNavigationDepartment);
      departmentArray.forEach((obj) => {
        obj.current = obj.ppwRecId === selectedNavigationDepartment.ppwRecId ? true : false;
      });
      dropDownOptions.value = departmentArray.length > 1 ? departmentArray : [];
    };
    // Fetch initial values
    const fetchInitialValues = () => {
      availableDepartments$.subscribe((value) => {
        availableDepartments.value = value;
      });
      activeDepartment$.subscribe((value) => {
        activeDepartment.value = value;
      });
      availablePortals$.subscribe((value) => {
        availablePortals.value = value;
      });
      currentUserIdentity$.subscribe((value) => {
        user.value = value;
      });
      const combinedStream = combineLatest([currentUserIdentity$, navigation$, availablePortals$]);
      combinedStream
        .pipe(
          tap((data) => {
            updateResults(data[1]).then(() => {
              const navdata = { ...data[1], user: data[0], availablePortals: data[2] };
              initNavigation(navdata);
            });
          })
        )
        .subscribe();
      fetchNewsItems();
    };
    const chatClick = () => {
      $emitter.emit('chat', true);
    };
    const toggleNotifications = () => {
      showNotifications.value = !showNotifications.value;
    };
    const newsItems = computed(() => store.getters['news/getNewsItems']);
    const goToPath = async (toDo) => {
      if (toDo.customerId) await store.dispatch('patient/setActivePatient', toDo.customerId);
      if (toDo.typeInfo.actionActivatesOsaEvaluationId) {
        await getOsaOverviewDetails({
          osaType: 'Evaluation',
          osaId: toDo.osaEvaluationId,
          licenseId: 0
        });
      }
      if (toDo.typeInfo.actionUrl) await router.push(toDo.typeInfo.actionUrl);
    };
    const handleNotificationClick = () => {
      const timestamp = new Date();
      window.localStorage.setItem('notificationLastClicked', timestamp);
      notificationLastClicked.value = timestamp;
      addGtmData('notification_icon_click');
    };
    const redirectToTodos = () => {
      $emitter.emit('todos');
      router.push('/');
    };
    const toggleMenu = () => {
      showConsignmentMenu.value = !showConsignmentMenu.value;
    };
    const hideMenu = () => {
      showConsignmentMenu.value = false;
    };
    const addGtmData = (event) => {
      window.dataLayer.push({
        event: event,
        unread_notifications_count: transformedToDos.value?.length,
        timestamp: new Date().toISOString()
      });
    };
    watch(transformedToDos, (newVal, oldVal) => {
      if (newVal != oldVal && notificationUnreadStatus.value) {
        addGtmData('unread_notifications');
      }
    });
    // Call fetchInitialValues when component is mounted
    onMounted(fetchInitialValues);
    return {
      menuItems,
      consignmentMenuItems,
      consignmentMenuCount,
      consignmentMenus,
      iconMenuItems,
      dropDownOptions,
      profileMenuItems,
      showConsignmentMenu,
      isChatActive,
      updateResults,
      selectedDepartmentChange,
      fetchResults,
      setPrescriberChatIframe,
      availableDepartments,
      activeDepartment,
      availablePortals,
      user,
      results,
      ...mapActions('navigation', ['fetchResults']),
      ...mapActions('login', ['logOut', 'selectedDepartmentChange']),
      initNavigation,
      fetchDepotMaterialDetails,
      fetchNewsItems,
      chatClick,
      showNotifications,
      toggleNotifications,
      newsItems,
      transformedToDos,
      goToPath,
      handleNotificationClick,
      latestDateTime,
      notificationUnreadStatus,
      toggleMenu,
      hideMenu,
      redirectToTodos,
      addGtmData
    };
  },
  watch: {
    consignmentMenuItems(value) {
      if (value !== null && value !== undefined) {
        this.consignmentMenuCount = value.length;
        this.consignmentMenus = value;
      }
    }
  },
  mounted() {
    this.fetchDepotMaterialDetails();
  },
  created() {},
  methods: {
    handleClick(url) {
      this.hideMenu();
      router.push(url);
    },
    onItemClick(item) {
      this.$emitter.emit('chat-close');
      if (!item) {
        return;
      }
      if (item.id === 'department-selector') {
        this.iconMenuItems = [];
        this.selectedDepartmentChange(item.ppwRecId).then(() => {
          router.push('/');
          this.fetchResults();
          pushDepartmentChangedEvent({});
          this.fetchDepotMaterialDetails();
          this.fetchNewsItems();
          this.$emitter.emit('department-change');
        });
      }
      if (item.type === 'Logout') {
        formLogout().then((r) => {
          window.localStorage.setItem('activeMyTodoToggle', false);
          this.setPrescriberChatIframe(false);
          window.location.replace('/?' + Math.random());
        });
      }
      if (item.type === 'GiveYourOpinion') {
        this.$emitter.emit('showFeedbackForm');
        return;
      }
      if (item.type === 'Pien') {
        window.open(item.href); // Added for E40-7629
        return;
      }
      if (item.href === null || item.href === undefined) {
        router.push('/');
      } else {
        router.push(item.href);
      }
    }
  }
};
</script>
